import { Modal, Textarea, Button } from "flowbite-react";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { useState } from "react";
import { createStockInventory } from "@/common/services/stock-inventory.api";

type Props = {
  onClose: () => void;
  onSave: () => void;
};

export default function ModalCreateStockInventory(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const [observation, setObservation] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const handleCloseModal = () => {
    props.onClose && props.onClose();
  };
  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    setIsSaving(true);
    try {
      const result = await createStockInventory({ observations: observation });

      if (result.ok) {
        notifySuccess("Novo inventário criado com sucesso!");
        props.onSave();
      } else {
        notifyError(result.message || "Ocorreu um erro ao criar o inventário.");
      }
    } catch (err) {
      notifyError((err as Error).message);
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <Modal show={true} onClose={handleCloseModal}>
      <Modal.Header>
        <h2 className="text-black">Cadastrar Novo Inventário</h2>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="space-y-4">
            <div>
              <label
                htmlFor="observation"
                className="mb-2 block text-sm font-medium text-gray-900 dark:text-black"
              >
                Observações
              </label>
              <Textarea
                id="observation"
                placeholder="Adicione qualquer observação relevante aqui..."
                value={observation}
                onChange={(e) => setObservation(e.target.value)}
                rows={4}
                required
                color={"black"}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" isProcessing={isSaving} disabled={isSaving}>
            Salvar
          </Button>
          <Button color="red" onClick={handleCloseModal} disabled={isSaving}>
            Cancelar
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
